export class Coordinates {
  constructor(
    public latitude: number,
    public longitude: number
  ) {}

  public static hydrate(coordinates: Coordinates): Coordinates {
    return new Coordinates(coordinates.latitude, coordinates.longitude);
  }

  public static getDistance(coordinates1: Coordinates, coordinates2: Coordinates): number {
    const R = 6371; // Radius of the earth in km
    const dLat = Coordinates.deg2rad(coordinates2.latitude - coordinates1.latitude);
    const dLon = Coordinates.deg2rad(coordinates2.longitude - coordinates1.longitude);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(Coordinates.deg2rad(coordinates1.latitude)) *
        Math.cos(Coordinates.deg2rad(coordinates2.latitude)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c * 1000; // Distance in m
  }

  private static deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }
}
